import decorationPlugin, { decorationStateKey, hoverDecoration, removeDecoration } from './pm-plugin';
/**
 * Decorations plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */
export var decorationsPlugin = function decorationsPlugin() {
  return {
    name: 'decorations',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'decorationPlugin',
        plugin: function plugin() {
          return decorationPlugin();
        }
      }];
    },
    actions: {
      hoverDecoration: hoverDecoration,
      removeDecoration: removeDecoration
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return {
          decoration: undefined
        };
      }
      return decorationStateKey.getState(editorState);
    }
  };
};